import {
  isNonEmptyArray,
  isNonEmptyObject,
  isNonEmptyString
} from '@/utils/checks'
import { Center, ProviderType } from '@/types/models'
export const shouldShowDistanceLabel = ({
  providerType,
  rankingInfo,
  showDistanceLabel,
  centerLocations,
  refinementLocation
}: {
  providerType: ProviderType
  rankingInfo?: { geoDistance?: number | string }
  showDistanceLabel: boolean
  centerLocations: Center['locations']
  refinementLocation: string
}): boolean => {
  const location = isNonEmptyString(refinementLocation)
    ? refinementLocation.split(',')[0]
    : ''
  return (
    showDistanceLabel &&
    isNonEmptyObject(rankingInfo) &&
    providerType !== ProviderType.VIRTUAL &&
    isNonEmptyArray(centerLocations) &&
    !centerLocations.includes(location)
  )
}
